import { render } from "./About.vue?vue&type=template&id=59425a64"
const script = {}
script.render = render

export default script